import React, { useEffect } from 'react';
import {numberWithCommas} from 'lib/utils';

function SyrupHeader({name, point}) {
  useEffect(() => {});
  return (
    <div className="top_name">
      <span className="left">{name}님, 안녕하세요.</span>
      <span className="right">
        <span style={{width: "70%", display: "inline-block", wordBreak: "break-all"}}>
          {numberWithCommas(point)}
        </span>
        <div>P</div>
      </span>
    </div>
  )
}

export default SyrupHeader;
